"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createNumberFormat = createNumberFormat;
exports.CurrencyFormat = exports.NumberFormat = void 0;

var _lodashEs = require("lodash-es");

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var NumberFormat = {};
exports.NumberFormat = NumberFormat;
NumberFormat.DEFAULT = {};
NumberFormat.NO_FRACTION = __assign(__assign({}, NumberFormat.DEFAULT), {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
var CurrencyFormat = {};
exports.CurrencyFormat = CurrencyFormat;
CurrencyFormat.DEFAULT = {
  style: 'currency',
  currencyDisplay: 'code',
  withCurrency: false
};
CurrencyFormat.DEFAULT_NO_FRACTION = __assign(__assign({}, CurrencyFormat.DEFAULT), NumberFormat.NO_FRACTION);
/* Recommended presets */

CurrencyFormat.WITH_CURRENCY_CODE = __assign(__assign({}, CurrencyFormat.DEFAULT), {
  currencyDisplay: 'code',
  withCurrency: true
});
CurrencyFormat.WITH_CURRENCY_SYMBOL = __assign(__assign({}, CurrencyFormat.DEFAULT), {
  currencyDisplay: 'symbol',
  withCurrency: true
});
CurrencyFormat.WITH_CURRENCY_CODE_NO_FRACTION = __assign(__assign({}, NumberFormat.NO_FRACTION), CurrencyFormat.WITH_CURRENCY_CODE);
CurrencyFormat.WITH_CURRENCY_SYMBOL_NO_FRACTION = __assign(__assign({}, NumberFormat.NO_FRACTION), CurrencyFormat.WITH_CURRENCY_SYMBOL);
/* Custom purpose-made presets  */

CurrencyFormat.WITH_CURRENCY_CODE_DOUBLE_FRACTION = __assign(__assign({}, CurrencyFormat.DEFAULT), {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  withCurrency: true
});
var UnitFormat = {};
UnitFormat.DEFAULT = {
  style: 'unit',
  unitDisplay: 'long'
};
var CURRENCY_REMOVAL_RE = /(?:^[^\d,.]+)|(?:[^\d,.]+$)/gi;

function createNumberFormat(locale) {
  var getFormatter = (0, _lodashEs.memoize)(function (options) {
    return new Intl.NumberFormat(locale, options);
  }, function (options) {
    return JSON.stringify(options, Object.keys(options).sort());
  });

  function formatNumber(value, options) {
    if (options === void 0) {
      options = NumberFormat.DEFAULT;
    }

    return getFormatter(options).format(value);
  }

  function formatCurrency(
  /** amount in cents */
  value, currency, options) {
    if (options === void 0) {
      options = CurrencyFormat.DEFAULT;
    }

    var _a = __assign(__assign(__assign({}, CurrencyFormat.DEFAULT), options), {
      style: 'currency',
      currency: currency
    }),
        withCurrency = _a.withCurrency,
        intlOptions = __rest(_a, ["withCurrency"]);

    var result = getFormatter(intlOptions).format(value / 100);

    if (!withCurrency) {
      result = result.replace(CURRENCY_REMOVAL_RE, '');
    }

    if (process.env.NODE_ENV === 'test') {
      return result.replace(/\s/gi, ' ');
    }

    return result;
  }

  function formatCurrencyRange(currency,
  /** first amount in cents */
  value1,
  /** second amount in cents */
  value2, options) {
    if (options === void 0) {
      options = CurrencyFormat.DEFAULT;
    }

    return [value1, value2].filter(function (value) {
      return value !== undefined && value !== null;
    }).map(function (value) {
      return formatCurrency(value, currency, options);
    }).join(' - ');
  }

  function formatUnit(value, unit, options) {
    if (options === void 0) {
      options = UnitFormat.DEFAULT;
    }

    var intlOptions = __assign(__assign(__assign({}, UnitFormat.DEFAULT), options), {
      style: 'unit',
      unit: unit
    });

    return getFormatter(intlOptions).format(value);
  }

  return {
    formatNumber: formatNumber,
    formatCurrency: formatCurrency,
    formatCurrencyRange: formatCurrencyRange,
    formatUnit: formatUnit
  };
}